/* eslint-disable function-paren-newline */
/* eslint-disable curly */
/* eslint-disable nonblock-statement-body-position */
import { print } from 'graphql/language/printer';
import { GET_USER_ACCESS } from '../../queries/userAccess';
import { request } from '../../utils/request';
import { useUserAccess } from '../../hooks/context/useUserAccess.hook';

export class UserService {
  constructor(private userId: string) {}

  async getUserAccess(): Promise<IUserAccess[]> {
    const response = await request(print(GET_USER_ACCESS), {
      user: this.userId,
    });
    const { accesses } = response.data;
    return accesses;
  }

  static useSitesFromAccess(sorted = true): string[] {
    const [userAccess] = useUserAccess();

    const sortFunction = (a: string, b: string) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    };

    if (userAccess) {
      const sitesArray = userAccess.map((userAccess) => {
        return userAccess.site.domain;
      });

      if (sorted) {
        return sitesArray.sort(sortFunction);
      }

      return sitesArray;
    }

    return [];
  }

  static useSitesWithIdAndDomainFromAccess(
    sorted = true,
  ): { siteId: string; domain: string }[] {
    const [userAccess] = useUserAccess();

    if (userAccess) {
      let sitesArray = userAccess.map((access) => ({
        siteId: access.site.id,
        domain: access.site.domain,
      }));

      if (sorted)
        sitesArray = sitesArray.sort((a, b) =>
          a.domain.localeCompare(b.domain),
        );

      return sitesArray;
    }

    return [];
  }
}
